/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * grimoire/v1/automation_phase.proto
 * OpenAPI spec version: version not set
 */

/**
 * PhaseType defines the type of phase for an automation trigger.

 - PHASE_TYPE_UNSPECIFIED: Unspecified phase type.
 - PHASE_TYPE_PRE: Pre-processing phase.
 - PHASE_TYPE_MAIN: Main processing phase.
 - PHASE_TYPE_POST: Post-processing phase.
 */
export type V1PhaseType = (typeof V1PhaseType)[keyof typeof V1PhaseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const V1PhaseType = {
  PHASE_TYPE_UNSPECIFIED: 'PHASE_TYPE_UNSPECIFIED',
  PHASE_TYPE_PRE: 'PHASE_TYPE_PRE',
  PHASE_TYPE_MAIN: 'PHASE_TYPE_MAIN',
  PHASE_TYPE_POST: 'PHASE_TYPE_POST',
} as const;
